var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "basket-checkout-page-container",
          attrs: { id: "checkout-page" }
        },
        [
          _vm.basketItems !== undefined && _vm.getGtmEventBasketItems.length > 0
            ? _c("pc-gtm-event-logger", {
                key: _vm.getGtmEventBasketItems.length,
                attrs: {
                  eventName: _vm.GTMEventName,
                  basketProducts: _vm.getGtmEventBasketItems || []
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "text-center bg-white main-heading-page",
              attrs: { id: "mybasket-heading" }
            },
            [
              _c("h2", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$resourceString["basket.BasketPageTitle"]) +
                    "\n            "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-fluid basket-checkout-page-details" },
            [
              _c("div", { staticClass: "row align-items-start" }, [
                _c(
                  "div",
                  {
                    class: !_vm.isSideBar
                      ? "col-12"
                      : "col-12 col-lg-8 col-xl-9"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "basket-list-warpper",
                        attrs: { id: "basket-container" }
                      },
                      [
                        _vm.basketItems &&
                        _vm.basketItems.SiteItems &&
                        _vm.basketItems.SiteItems.length > 0
                          ? _c(
                              "div",
                              { staticClass: "basket-item-list-row" },
                              [
                                _c("pc-basket-accordion", {
                                  attrs: {
                                    title:
                                      _vm.$resourceString[
                                        "myBasket.Label.IndividualSamples"
                                      ],
                                    sectionId: "#IndividualSamples",
                                    itemCount: _vm.basketCount.siteItems,
                                    isDefaultExpand:
                                      _vm.isAccordionExpand === _vm.siteItems
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "basket-item-list show",
                                    class: {
                                      show:
                                        _vm.isAccordionExpand === _vm.siteItems
                                    },
                                    attrs: { id: "IndividualSamples" }
                                  },
                                  [
                                    _c("basket-item", {
                                      attrs: {
                                        listItems: _vm.basketItems.SiteItems,
                                        clearAllTitle:
                                          _vm.$resourceString[
                                            "basket.ClearWebsiteItems"
                                          ],
                                        isClearAll: true,
                                        listName: _vm.siteItems
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.basketItems &&
                        _vm.basketItems.ProjectItems &&
                        _vm.basketItems.ProjectItems.length > 0
                          ? _c(
                              "div",
                              { staticClass: "basket-item-list-row" },
                              [
                                _c("pc-basket-accordion", {
                                  attrs: {
                                    title:
                                      _vm.$resourceString[
                                        "myBasket.Label.ProjectSamples"
                                      ],
                                    sectionId: "#ProjectSamples",
                                    itemCount: _vm.basketCount.projectItems,
                                    isDefaultExpand:
                                      _vm.isAccordionExpand === _vm.projectItems
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "basket-item-list collapse",
                                    class: {
                                      show:
                                        _vm.isAccordionExpand ===
                                        _vm.projectItems
                                    },
                                    attrs: { id: "ProjectSamples" }
                                  },
                                  [
                                    _c("basket-item", {
                                      attrs: {
                                        listItems: _vm.basketItems.ProjectItems,
                                        clearAllTitle:
                                          _vm.$resourceString[
                                            "basket.ClearProjectsItems"
                                          ],
                                        isClearAll: true,
                                        listName: _vm.projectItems
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.basketItems &&
                        _vm.basketItems.TrayItems &&
                        _vm.basketItems.TrayItems.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "basket-item-list-row basket-list-tray-items"
                              },
                              [
                                _c("pc-basket-accordion", {
                                  attrs: {
                                    title:
                                      _vm.$resourceString[
                                        "myBasket.Label.DesignTraySample"
                                      ],
                                    sectionId: "#DesignTraySample",
                                    itemCount: _vm.basketCount.trayItems,
                                    isDefaultExpand:
                                      _vm.isAccordionExpand === _vm.trayItems
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "basket-item-list collapse",
                                    class: {
                                      show:
                                        _vm.isAccordionExpand === _vm.trayItems
                                    },
                                    attrs: { id: "DesignTraySample" }
                                  },
                                  [
                                    _c("basket-item", {
                                      attrs: {
                                        listItems: _vm.basketItems.TrayItems,
                                        clearAllTitle:
                                          _vm.$resourceString[
                                            "basket.ClearTrayItems"
                                          ],
                                        isClearAll: true,
                                        listName: _vm.trayItems
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.basketItems.HasSiteItems &&
                        !_vm.basketItems.HasTrayItems &&
                        !_vm.basketItems.HasProjectItems
                          ? _c("pc-empty-basket")
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.saveForLater.SiteItems &&
                          _vm.saveForLater.SiteItems.length > 0) ||
                        (_vm.saveForLater.ProjectItems &&
                          _vm.saveForLater.ProjectItems.length > 0)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "basket-list-save-for-later-container"
                              },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "primary-heading font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "basket.SaveForLater.Title"
                                          ]
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.saveForLater.SiteItems &&
                                _vm.saveForLater.SiteItems.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "basket-item-list-row basket-list-save-for-later"
                                      },
                                      [
                                        _c("pc-basket-accordion", {
                                          attrs: {
                                            title:
                                              _vm.$resourceString[
                                                "myBasket.Label.IndividualSamples"
                                              ],
                                            sectionId:
                                              "#SaveForLaterItems_SiteItems",
                                            itemCount:
                                              _vm.saveForLaterCount.siteItems,
                                            isDefaultExpand:
                                              _vm.isAccordionExpand ===
                                              "saveForLater-" + this.siteItems
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basket-item-list collapse",
                                            class: {
                                              show:
                                                _vm.isAccordionExpand ===
                                                "saveForLater-" + this.siteItems
                                            },
                                            attrs: {
                                              id: "SaveForLaterItems_SiteItems"
                                            }
                                          },
                                          [
                                            _c("pcBasketSaveForLater", {
                                              attrs: {
                                                listName: "SiteItems",
                                                listItems:
                                                  _vm.saveForLater.SiteItems
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.saveForLater.ProjectItems &&
                                _vm.saveForLater.ProjectItems.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "basket-item-list-row basket-list-save-for-later"
                                      },
                                      [
                                        _c("pc-basket-accordion", {
                                          attrs: {
                                            title:
                                              _vm.$resourceString[
                                                "myBasket.Label.ProjectSamples"
                                              ],
                                            sectionId:
                                              "#SaveForLaterItems_ProjectItems",
                                            itemCount:
                                              _vm.saveForLaterCount
                                                .projectItems,
                                            isDefaultExpand:
                                              _vm.isAccordionExpand ===
                                              "saveForLater-" + _vm.projectItems
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basket-item-list collapse",
                                            class: {
                                              show:
                                                _vm.isAccordionExpand ===
                                                "saveForLater-" +
                                                  _vm.projectItems
                                            },
                                            attrs: {
                                              id:
                                                "SaveForLaterItems_ProjectItems"
                                            }
                                          },
                                          [
                                            _c("pcBasketSaveForLater", {
                                              attrs: {
                                                listName: "ProjectItems",
                                                listItems:
                                                  _vm.saveForLater.ProjectItems
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.isSideBar
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "checkout-basket-sidebar-warpper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "checkout-basket-sidebar-container"
                              },
                              [
                                _vm.basketItems.HasSiteItems ||
                                _vm.basketItems.HasTrayItems ||
                                _vm.basketItems.HasProjectItems
                                  ? _c("pc-basket-sidebar", {
                                      attrs: {
                                        individualSamples:
                                          _vm.basketItems &&
                                          _vm.basketItems.SiteItems &&
                                          _vm.basketItems.SiteItems.length > 0,
                                        individualSamplesCount:
                                          _vm.basketCount.siteItems,
                                        projectSamples:
                                          _vm.basketItems &&
                                          _vm.basketItems.ProjectItems &&
                                          _vm.basketItems.ProjectItems.length >
                                            0,
                                        projectSamplesCount:
                                          _vm.basketCount.projectItems,
                                        designTraySample:
                                          _vm.basketItems &&
                                          _vm.basketItems.TrayItems &&
                                          _vm.basketItems.TrayItems.length > 0,
                                        designTraySampleCount:
                                          _vm.basketCount.trayItems,
                                        nextLabel:
                                          _vm.$resourceString[
                                            "myBasket.Button.Continue"
                                          ],
                                        nextAction: function() {
                                          return _vm.continueToCheckOut(
                                            _vm.checkoutTypeMixed
                                          )
                                        },
                                        isNextDisabled: _vm.isErrorForSideBar(),
                                        isError: _vm.isErrorForSideBar(),
                                        errorMsg: _vm.errorMsgForSideBar()
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("pc-ideabook")
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("pc-page-loader", { attrs: { loader: _vm.loader } }),
      _vm._v(" "),
      _vm.basketItems.HasSiteItems && _vm.basketItems.AskToAddIdeabook
        ? _c("pc-ideabook-recommendation-modal", {
            attrs: { continueToCheckOut: _vm.continueToCheckOutIdeabook }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }